'use strict';

module.exports = [function () {
     return {
        replace: true,
        scope: true,        
        template: require('./tableButtonGroupAction.html')
    };
}];




//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/directives/layout/tableButtonGroupAction.js
// module id = 374
// module chunks = 0